import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { promptConfirm } from './prompt-confirm.js'

export async function promptMultiple(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind,
  type: string
): Promise<boolean> {
  if (kind === 'form') {
    return type === 'file' ? promptConfirm(context, 'Allow multiple files?', false) : false
  }

  return ['select', 'relationship'].includes(type)
    ? promptConfirm(context, 'Allow multiple values?', false)
    : false
}
